// src/db.js
import {
  collection, doc, addDoc, updateDoc, deleteDoc,
  getDocs, getDoc, query, orderBy, serverTimestamp,
} from "firebase/firestore";
import { db } from "./firebase";

const COL = "recipes";

/* ── READ ──────────────────────────────────────────── */
export async function fetchRecipes() {
  const q = query(collection(db, COL), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function fetchRecipe(id) {
  const snap = await getDoc(doc(db, COL, id));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

/* ── WRITE ─────────────────────────────────────────── */
export async function createRecipe(data) {
  const ref_ = await addDoc(collection(db, COL), {
    ...data,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return ref_.id;
}

export async function updateRecipe(id, data) {
  await updateDoc(doc(db, COL, id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteRecipe(id, imageUrl) {
  await deleteDoc(doc(db, COL, id));
  if (imageUrl) {
    try {
      const imgRef = ref(storage, imageUrl);
      await deleteObject(imgRef);
    } catch (_) { /* image may not exist */ }
  }
}

/* ── IMAGE ─────────────────────────────────────────── */
export async function uploadImage(file, recipeId) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", "ichjcfrg");
  formData.append("folder", "recipes");
  const res = await fetch(
    "https://api.cloudinary.com/v1_1/dexwqedcs/image/upload",
    { method: "POST", body: formData }
  );
  const data = await res.json();
  return data.secure_url;
}

